import styled from "styled-components";
import { HTMLProps } from "react";

export const UppercaseButton = styled.button<HTMLProps<HTMLButtonElement>>`
  text-transform: uppercase;
`;
